import * as React from "react"
import { LogoContextProvider } from "../context/logoContext"
import AnalyticsConsent from "./AnalyticsConsent"

const WrapRootElement = ({ children }) => (
  <LogoContextProvider>
    {children}
    <AnalyticsConsent />
  </LogoContextProvider>
)

export default WrapRootElement
